import React, { useEffect, useState } from 'react'
import StarIcon from '@mui/icons-material/Star';
import StairsIcon from '@mui/icons-material/Stairs';
import { Oval } from 'react-loader-spinner';
// import ProgressBar from "@ramonak/react-progress-bar";
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import { baseUrl, path } from '../../constants';
import { Link } from 'react-router-dom';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import HistoryIcon from '@mui/icons-material/History';
import {api} from '../../api'
import CancelIcon from '@mui/icons-material/Cancel';
import { toast } from 'react-toastify';

export default function Earnings() {
    const [data, setData] = useState({})
    const [loading, setLoading] = useState(true)
    const [request, setRequest] = useState(false)
    const [history, setHistory] = useState(false)

    useEffect(() => {
        api.get(path.enrollments).then(response => {
            const data = response.data
            if(data.success){
                setData(data)
            }
        }).finally(() => setLoading(false))
    }, [])
    
  return ( 
    <div className='flex flex-col flex-1 overflow-auto gap-4'>
            <div className='w-full flex justify-between items-center max-md:items-stretch p-4 bg-main rounded-md shadow-sm max-md:flex-col max-md:gap-4'>
                <p className='text-white font-bold text-[18px] max-md:text-[14px]'>Earnings & Enrollments</p>
                <p className='text-main text-[14px] px-4 py-2 rounded-sm bg-white font-bold'>Total Earning { (parseFloat(data.total_in || 0)?.toLocaleString('en-US', {maximumFractionDigits: 2})) + ' ETB'}</p>
                <p className='text-main text-[14px] px-4 py-2 rounded-sm bg-white font-bold'>Balance {(parseFloat(data.balance || 0)?.toLocaleString('en-US', {maximumFractionDigits: 2})) + ' ETB'}</p>
                <div className='flex items-center gap-2 max-md:justify-center'>
                    <button onClick={() => setRequest(true)} className='bg-black px-4 py-2 font-bold text-white rounded-md flex items-center justify-center gap-1 max-md:text-xs'>
                        <AccountBalanceIcon style={{color: '#ffffff', fontSize: 17}}>Filled</AccountBalanceIcon>
                        Withdraw
                    </button>
                    <button onClick={() => setHistory(true)} className='bg-black px-4 py-2 font-bold text-white rounded-md flex items-center justify-center gap-1 max-md:text-xs'>
                        <HistoryIcon style={{color: '#ffffff', fontSize: 17}}>Filled</HistoryIcon>
                        Withdrawal History
                    </button>
                </div>
            </div>
            {loading ? (
                <div className='flex flex-col items-center gap-3'>
                    <p className='text-black text-[15px]'>Loading data...</p>
                    <Oval
                        visible={true}
                        height="30"
                        width="30"
                        color="#52a4e0"
                        secondaryColor="#ffffff"
                        ariaLabel="oval-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                        strokeWidth={3}
                        />
                </div>
            ) :(
                <table className='earnings'>
                    <thead className='bg-black'>
                        <tr className='text-white text-left'>
                            <th className='p-2 max-md:text-xs'>User Name</th>
                            <th className='p-2 max-md:text-xs'>Enrolled Course</th>
                            <th className='p-2 max-md:text-xs'>Enrolled Date</th>
                            <th className='p-2 max-md:text-xs'>Earning</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.enrolls?.map(enroll => (
                            <tr>
                                <td className='p-2 max-md:text-xs'>{`${enroll.user?.firstName} ${enroll.user?.lastName}`}</td>
                                <td className='p-2 max-md:text-xs'>{enroll.course?.title}</td>
                                <td className='p-2 max-md:text-xs'>{enroll.updatedAt?.split('T')?.at(0)}</td>
                                <td className='p-2 max-md:text-xs'><span className='text-[#00ff00] font-bold bg-black px-2 py-1 rounded-md'>+{(enroll.course?.price / 1.1)?.toLocaleString()}</span></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
             {!loading && !data?.enrolls?.length && <p className='text-center'>You have no enroll history yet!</p>}
            {request && <WithdrawalRequest setRequest={setRequest} balance={parseInt(data.balance) || 0} />}
            {history && <WithdrawalHistory _setHistory={setHistory} />}
        </div>
    )
}

function WithdrawalRequest({ balance, setRequest }){
    const [submitting, setSubmitting] = useState(false)

    const requestWithdraw = (e) => {
        e.preventDefault()
        setSubmitting(true)
        api(path.withdrawal + '/', {
            method: 'post',
            data: {
                bank_name: e.target.bank_name.value,
                account_name: e.target.account_name.value,
                account_number: e.target.account_number.value,
            }
        }).then(response => {
            if(response.data.success){
                toast.success('Success! we will update you shortly.', {
                    hideProgressBar: true
                })
                setRequest(null)
            } else {
                toast.error('Sorry. something went wrong!', {
                    hideProgressBar: true
                })
            }
        }).finally(() => setSubmitting(false))
    }

    return (
        <div className='fixed bg-[#00000060] z-[999999] inset-0 flex items-center justify-center'>
            <form onSubmit={requestWithdraw} className='bg-white flex flex-col items-center gap-6 p-4 rounded-md'>
                <h1>Request Withdraw</h1>
                {!balance && <p className='text-[#ff0000] text-sm bg-[#ff000040] px-4 py-2 rounded-md text-center font-bold'>You Have Insufficient Balance To Withdraw!</p>}
                <input name='bank_name' placeholder={'Bank Name'} type='text' className='border-[1px] border-solid border-[#00000090] text-black placeholder:text-[#434343] p-2 w-[300px]' required/>
                <input name='account_name' placeholder={'Account Name'} type='text' className='border-[1px] border-solid border-[#00000090] text-black placeholder:text-[#434343] p-2 w-[300px]' required/>
                <input name='account_number' placeholder={'Account Number'} type='number' className='border-[1px] border-solid border-[#00000090] text-black placeholder:text-[#434343] p-2 w-[300px]' required/>
                <input name='' disabled placeholder={'Withdraw Amount: ' + balance} type='number' className='border-[1px] bg-[#00000020] border-solid border-[#00000090] text-black placeholder:text-[#434343] p-2 w-[300px]' />
                <div className='flex self-stretch gap-2'>
                    <button disabled={submitting || !balance} type='submit' className={`${(!balance) ? 'bg-[#a3a3a3]' : 'bg-main'} text-white text-[14px] flex-1 p-2 flex items-center justify-center`}>
                    {submitting ? (
                            <Oval
                                visible={true}
                                height="21"
                                width="21"
                                color="#ffffff"
                                ariaLabel="oval-loading"
                                wrapperStyle={{}}
                                wrapperClass=""
                                strokeWidth={3}
                            />
                        ) : 'Request'}
                    </button>
                    <button onClick={() => setRequest(false)} className='border-[1px] border-[#00000070] p-2 text-[14px] flex-1'>
                        Cancel
                    </button>
                </div>
            </form>
        </div>
    )
}


function WithdrawalHistory({ _setHistory }){
    const [loading, setLoading] = useState(true)
    const [history, setHistory] = useState([])

    const fetchHistory = (e) => {
        api.get(path.withdrawal).then(response => {
            let data = response.data
            if(data.success){
                setHistory(data.withdrawals)
            }
        }).finally(() => setLoading(false))
    }

    useEffect(fetchHistory, [])

    return (
        <div className='fixed bg-[#00000060] z-[999999] inset-0 flex items-center justify-center p-4'>
            <div className='bg-white flex flex-col items-center max-md:items-start overflow-x-auto gap-6 p-1 rounded-md relative'>
           
            {loading ? (
                <div className='flex flex-col items-center gap-3'>
                    <p className='text-black text-[15px]'>Loading history...</p>
                    <Oval
                        visible={true}
                        height="30"
                        width="30"
                        color="#52a4e0"
                        secondaryColor="#ffffff"
                        ariaLabel="oval-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                        strokeWidth={3}
                        />
                </div>
            ) :(
                <table className='earnings'>
                    <thead className='bg-black'>
                        <tr className='text-white text-left'>
                            <th className='p-2 max-md:text-xs'>Amount</th>
                            <th className='p-2 max-md:text-xs'>Bank Name</th>
                            <th className='p-2 max-md:text-xs'>Account Name</th>
                            <th className='p-2 max-md:text-xs'>Account Number</th>
                            <th className='p-2 max-md:text-xs'>Status</th>
                            <th className='p-2 max-md:text-xs'>Deposited Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {history?.map(history => (
                            <tr>
                                <td className='p-2 max-md:text-xs'>{history.withdraw_amount}</td>
                                <td className='p-2 max-md:text-xs'>{history.bank_name}</td>
                                <td className='p-2 max-md:text-xs'>{history.account_name}</td>
                                <td className='p-2 max-md:text-xs'>{history.account_number}</td>
                                <td className='p-2 max-md:text-xs'><span className='text-[#00ff00] text-xs font-bold bg-black px-2 py-1 rounded-sm'>{['PENDING', 'PROCESSING', 'COMPLETED'][history.status - 1]}</span></td>
                                <td className='p-2 max-md:text-xs'>{history.deposited_date?.split('T')?.at(0)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
             {!loading && !history.length && <p>You have no withdrawal history yet!</p>}
             <button onClick={() => _setHistory(false)} className='outline-none bg-white rounded-full bg-none self-center'>
                <CancelIcon style={{fontSize: 25, color: '#000000'}}>Filled</CancelIcon>
             </button>
            </div>
            
        </div>
    )
}